import React from 'react';
import { useLocation } from 'react-router-dom';

import Page from 'App/components/Page';
import FindPatientPdxForm from './FindPatientPdxForm';

function FindPatientPdxPage() {
    const { search } = useLocation();
    const firstName = new URLSearchParams(search).get('firstName');
    const lastName = new URLSearchParams(search).get('lastName');
    return (
        <Page title="Search Options" showPageTitle>
            <div className="container page-wrapper">
                <FindPatientPdxForm paramFirstName={firstName} paramLastName={lastName} />
            </div>
        </Page>
    );
}

export default FindPatientPdxPage;
